import { useCallback } from "react";
import { useIntl } from "react-intl";

export type ILang = (idJson: string) => string;

const useMultiLanguage = () => {
  const intl = useIntl();

  const lang = useCallback((idJson: string) => {
    if (Object.keys(intl.messages).includes(idJson)) {
      return intl.formatMessage({ id: idJson, defaultMessage: idJson, description: idJson});
    } else {
      console.error(`[MISSING TRANSLATION] ${intl.locale}-locale: ${idJson}: `)
      return idJson;
    }
  }, [intl]);

  return { intl, lang };
};

export default useMultiLanguage;
